import { createContext, useContext } from "react";

export type FieldValues = {
  limitPrice?: string;
  amount?: string;
  total?: string;
};

type OrderFormContextType = {
  fieldValues: FieldValues;
  setLimitPrice: (value: string) => void;
  setAmount: (value: string) => void;
};

export const OrderFormContext = createContext<OrderFormContextType | undefined>(
  undefined
);

export const useOrderForm = () => {
  const context = useContext(OrderFormContext);
  if (context === undefined) {
    throw new Error("useProduct must be used within a ProductProvider");
  }
  return context;
};
